<template>
  <DsfFormControlBox class="ds-checkbox" :owner="_self" :block-class="{'ds-checkbox-readonly__disabled':$disabled }">
    <!-- <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false" />
      <slot name="error">
        <div v-if="errors.length" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template> -->
    <template v-slot:content>
      <!--只读状态只显示div-->
      <template v-if="readOnly&&!readOnlyNotShowDiv">
        <div class="ds-form-readonly">
          <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false" />
        </div>
      </template>
      <template v-else>
        <slot name="before"></slot>
        <!-- 输入框模式 -->
        <template v-if="showModel === 'text'">
          <el-input @keyup.native="keyupHandler($event)" v-model="inputValue" :placeholder="placeholder" :class="{ 'ds-error-border': errors.length > 0 }" :disabled="$disabled" @change="inputChangeHandler" @focus="inputFocusHandler" @blur="inputBlurHandler" />
          <template v-for="iv in inputValueOfAttach">
            <el-input v-if="attachOptions[iv] !== void 0" :key="iv+'_input'" :value="attachOptions[iv]" :disabled="$disabled" size="small" :class="{ 'is-bordered': border }" :style="{ width: attachWidth, marginRight: '8px', maxWidth: '100%'}" :placeholder="'请输入'+iv+'的内容'" :title="'请输入'+iv+'的内容'" @input="setAttach(iv, $event)" />
          </template>
        </template>
        <!-- 按钮模式 -->
        <el-checkbox-group v-else-if="isButton" v-model="selectValue" :disabled="$disabled" v-bind="options" @change="selectChange">
          <template v-for="(item, index) in realItems">
            <el-checkbox-button :key="index" :label="item[valueField]" :disabled="itemDisabled(item)">
              {{ item[optionsTextField] }}
            </el-checkbox-button>
          </template>
        </el-checkbox-group>
        <!-- 常规模式 -->
        <template v-else>
          <template v-if="isTree || direction=='horizontal'">
            <el-checkbox-group v-model="selectValue" :disabled="$disabled" v-bind="options" @change="selectChange">
              <template v-for="(item, index) in realItems">
                <div :key="index" class="el-checkbox-group-layout-item" :root="!(item.children && item.children.length)">
                  <div class="el-checkbox-group-children-label" :check-uid="item.uid">
                    <template v-if="item.children&& item.children.length">
                      {{ item[optionsTextField] }}
                    </template>
                    <template v-else>
                      <el-checkbox :key="index" :label="item[valueField]" :check-uid="item.uid" :border="border" :disabled="itemDisabled(item)">
                        {{ item[optionsTextField] }}
                      </el-checkbox>
                      <slot name="append-input">
                        <el-input 
                          v-if="attachOptions[item[valueField]] !== void 0" 
                          :disabled="itemDisabled(item)"
                          :value="attachOptions[item[valueField]]"
                          size="small"
                          class="ds-checkbox-input"
                          :class="{ 'is-bordered': border }"
                          :style="{ width: attachWidth }"
                          placeholder="请输入内容"
                          @input="setAttach(item[valueField], $event)" />
                      </slot>
                    </template>
                  </div>
                  <div v-if="item.children && item.children.length" class="el-checkbox-group-children-value">
                    <ul v-for="(itemArray, index) in arrayTo2Array(item.children,treeMaxRowNum)" :key="index" class="el-checkbox-group-children-value-grid">
                      <li class="el-checkbox-group-children-value-grid-item" :check-uid="item.uid" v-for="(item, index) in itemArray" :key="index">
                        <el-checkbox :key="index" :label="item[valueField]" :border="border" :disabled="itemDisabled(item)">
                          {{ item[optionsTextField] }}
                        </el-checkbox>
                        <slot name="append-input">
                          <el-input v-if="attachOptions[item[valueField]] !== void 0" :value="attachOptions[item[valueField]]" size="small" class="ds-checkbox-input" :class="{ 'is-bordered': border }" :style="{ width: attachWidth }" placeholder="请输入内容" @input="setAttach(item[valueField], $event)" />
                        </slot>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </el-checkbox-group>
          </template>
          <template v-else>
            <el-checkbox-group v-model="selectValue" :disabled="$disabled" style="display:block" @change="selectChange">
              <div class="ds-checkbox-grid-layout">
                <div :style="{'width':itemWidth}" v-for="(item, index) in realItems" :key="index">
                  <el-checkbox :key="index" :label="item[valueField]" :check-uid="item.uid" :border="border" :disabled="itemDisabled(item)">
                    {{ item[optionsTextField] }}
                  </el-checkbox>
                  <slot name="append-input">
                    <el-input 
                      v-if="attachOptions[item[valueField]] !== void 0" 
                      :value="attachOptions[item[valueField]]"
                      :disabled="itemDisabled(item)"
                      size="small"
                      class="ds-checkbox-input"
                      :class="{ 'is-bordered': border }"
                      :style="{ width: attachWidth }"
                      placeholder="请输入内容"
                      @input="setAttach(item[valueField], $event)" />
                  </slot>
                </div>
              </div>
            </el-checkbox-group>
          </template>
        </template>
      </template>
      <slot name="error">
        <div v-if="errors.length" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>

<script>
export default dsf.component({
  name: "DsfCheckBox",
  mixins: [$mixins.formControl, $mixins.itemsMixins],
  ctrlCaption: "多选",
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    // 需要禁用选项的value值得集合
    disabledItemValues: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      validator: function (value) {
        // 0: 普通；1：带边框；2：按钮
        return [0, 1, 2].indexOf(parseInt(value)) !== -1;
      },
      default: 0
    },
    maxChooseNum: {
      type: Number,
      default: -1
    },
    minChooseNum: {
      type: Number,
      default: -1
    },
    // 排列方式
    direction: {
      default: "horizontal"
    },
    placeholder: {
      type: String,
      default: "请输入"
    },
    readOnlyNotShowDiv: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      multiple: true,
      //允许接受回车聚焦
      allowEnterFocus: true
    };
  },
  computed: {
    border() {
      return this.type === 1;
    },
    isButton() {
      return this.type === 2;
    },
    options() {
      const opt = {};
      if (this.maxChooseNum >= 0) {
        opt.max = this.maxChooseNum;
      }
      if (this.minChooseNum >= 0) {
        opt.min = this.minChooseNum;
      }
      return opt;
    },
    inputValueOfAttach() {
      return _.uniq(this?.inputValue?.split(",") || []);
    },
    isTree() {
      return (
        this.realItems.findIndex((ite) => {
          return !!ite?.children?.length;
        }) > -1
      );
    },
    itemWidth() {
      let direction = this.direction;
      if (direction == "vertical") direction = 1;
      return 100 / direction + "%";
    },
    $disabled() {
      if (this.readOnlyNotShowDiv && this.readOnly) {
        return true;
      }
      return this.disabled;
    }
  },
  methods: {
    itemDisabled(item) {
      if (this.$disabled) {
        return true;
      }
      return item.disabled || this.disabledItemValues.indexOf(item[this.valueField]) > -1;
    },
    arrayTo2Array(array, maxLen) {
      const twoArray = [];
      let i = 0;
      array.forEach((ite) => {
        i++;
        if (i > maxLen) {
          i = 1;
        }
        if (i == 1) {
          twoArray.push([]);
        }
        twoArray[twoArray.length - 1].push(ite);
      });
      return twoArray;
    },
    inputChangeHandler() {
      // 文本框显示模式时的监听（比如单选框组件用）
      let vs = _.uniq((this.inputValue || "").split(",")),
        hasItem = true;

      this.inputValue = vs.join(",");

      let realItemsV = [];
      dsf.deepForEach(
        this.realItems,
        (item) => {
          if (!item?.children) {
            realItemsV.push(item.value);
          }
        },
        {
          children: "children"
        }
      );
      _.forEach(vs, (v) => {
        if (!realItemsV.includes(v)) {
          hasItem = false;
        }
      });
      if (hasItem) {
        this.initValue(vs);
      } else {
        this.initValue(null);
        this.inputValue = "";
      }
    }
  },
  watch: {
    items: {
      handler(v, ov) {
        let index = 0;
        if (v) {
          dsf.deepForEach(v, (it, level, i, parent) => {
            it.uid = index++;
          });
        }
      },
      immediate: true
    }
  }
});
</script>
